import Vue from 'vue'
// import 'normalize.css/normalize.css'
import ElementUI from 'element-ui'
import Empty from '@/components/empty'
import UmyUi from 'umy-ui'
import uploader from 'vue-simple-uploader'
// 注意样式引入的顺序
import 'umy-ui/lib/theme-chalk/ux-grid.css'
import '@/styles/element-variables.scss'
import '@/styles/index.scss'
import App from './App'
import store from './store'
import router from './router'
import i18n from './i18n'
import '@/icons'
import '@/permission'
import '@/api/index'
import VueBus from './utils/vue-bus'
import './utils/main-config'
import permission from '@/directive/permission/index'
import dragscroll from '@/directive/dragscroll/index'
import jwLoadImg from '@/directive/jw-load-img/index'

const Echarts = require('echarts')
Vue.prototype.echarts = Echarts

Vue.use(Empty)
Vue.use(uploader)
Vue.use(permission)
Vue.use(dragscroll)
Vue.use(jwLoadImg)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */

// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

Vue.use(ElementUI, {
  size: 'small', // window.innerWidth >= 1920 ? null :
  zIndex: 2001
})
Vue.use(UmyUi)
Vue.use(VueBus)
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
